<template>
  <div style="padding:0;margin:0;height:100%;">
    <el-row style="height:55px;padding-bottom:15px;">
      <el-col :span="3">
        <el-button type="primary" icon="el-icon-plus" @click="add">添加设备</el-button>
      </el-col>
      <el-col :span="6">
        <searcher target="device"></searcher>
      </el-col>
    </el-row>
    <el-row style="height:calc(100% - 55px - 42px);">
      <devices></devices>
    </el-row>
    <el-row style="height:42px;">
      <pagination target="device"></pagination>
    </el-row>

    <DeviceEdit></DeviceEdit>
  </div>
</template>

<script>
  import Devices from "@/components/tables/Device.vue";
  import Pagination from "@/components/PageNations/Complete.vue";
  import Searcher from "@/components/input/Search.vue";
  import DeviceEdit from '@/components/Form/DeviceEdit.vue';
  import VueEvent from "@/models/VueEvent.js";
  export default {
    components: {
      Devices,
      Pagination,
      Searcher,
      DeviceEdit
    },
    methods: {},
    data() {
      return {

      };
    },
    mounted() {},
    methods: {
      add() {
        VueEvent.$emit("addDevice");
      }
    }
  };

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Device.vue